module.exports = __webpack_public_path__ + "static/media/isdoctorplan-ent1@2x.de934e47.png";